import { Badge, Box, styled } from '@mui/material';

export const MenuButton = styled(Box)(() => ({
	cursor: 'pointer',
	color: '#474747',
	width: '100%',
	aspectRatio: '1 / 1',
	borderRadius: '16px',
	background: '#fff',
	padding: '6px',
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	maxWidth: '150px',

	'&:hover': {
		boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.3)',
		background: '#ffffff89',
	},
	'&:active': {
		boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.3)',
		background: '#ffffff89',
	},
}));

export const IconWrap = styled(Box)(() => ({
	width: '48px',
	height: '48px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	'& svg': {
		color: '#474747',
		width: '42px',
		height: '42px',
	},
	'& svg [stroke]': {
		strokeWidth: '1.5px !important',
	},
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		minWidth: '18px',
		height: '18px',
		padding: '0 5px',
		borderRadius: '9px',
		background: theme.palette.primary.main,
		color: '#fff',
		fontSize: '10px',
		fontWeight: 700,
		boxShadow: '0px 2px 6px rgba(32, 144, 255, 0.35)',
	},
	'& .MuiBadge-dot': {
		minWidth: '10px',
		height: '10px',
		borderRadius: '50%',
	},
}));
